import { Box } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import SettingsInput from 'components/Settings/SettingsInput'
import Slider from 'components/base/Slider'
import { MAX_ASSET_VOLUME } from 'constant'
import { TranslationContext } from 'contexts/TranslationContext'
import { ReactComponent as VolumeIcon } from '~/assets/video-player/ic_volume.svg'
import styles from './volumeField.module.scss'

// ---

const maxAssetVolume = 100 * MAX_ASSET_VOLUME

type Props = {
  muted: boolean,
  onChangeMuted: (x: boolean) => void,
  volume: number,
  onChangeVolumeCommit: (x: number) => void
  isVideoSettings?: boolean
}

// TODO: refactor to SliderSettings component
export default function VolumeFieldAudio(props: Props) {
  const {
    muted = false,
    volume = 0,
    onChangeVolumeCommit = () => {},
    isVideoSettings,
  } = props

  const [ value, setValue ] = useState(volume)
  const { t } = useContext(TranslationContext)

  useEffect(() => {
    setValue(volume)
  }, [ volume ])

  const stringValue = value.toString()

  return (
    <Box className={styles.container} display={isVideoSettings ? 'block' : 'flex'} justifyContent="space-between">
      {isVideoSettings ? '' : <Box color="var(--text-color)">{t('FORM_FIELD_LABEL_VOLUME')}</Box>}
      <Box display="flex" alignItems="center">
        <Box
          display="flex"
          alignItems="flex-start"
          gridGap="15px"
          justifyContent={isVideoSettings ? 'flex-start' : 'space-between'}
        >
          <VolumeIcon />
          <Slider
            min={0}
            max={maxAssetVolume}
            step={1}
            disabled={muted}
            value={value}
            classes={{
              root: styles.sliderRoot,
              track: styles.track,
              mark: styles.mark,
              markActive: styles.markActive,
              thumb: styles.thumb,
            }}
            scale={(x: number) => 0.25 * x}
            onChange={setValue}
            onChangeCommitted={onChangeVolumeCommit}
          />
        </Box>
        <SettingsInput
          onChange={() => {
            // eslint-disable-next-line no-nested-ternary
            const num = Math.min(maxAssetVolume, Math.max(0, value))
            setValue(num)
            onChangeVolumeCommit(num)
          }}
          inputProps={{
            mask: 'NUM%',
            onComplete: (x: string) => {
              if (x === ' ') return
              const str = x.includes('%') ? x.slice(0, -1) : x
              const num = parseInt(str)
              const value = isNaN(num) ? 0 : num
              setValue(value)
            },
            lazy: stringValue === '',
            blocks: {
              NUM: {
                mask: Number,
                min: 0,
                max: 100000,
                radix: '.',
                scale: 1,
              },
            },
            placeholder: `${maxAssetVolume}%`,
            value: stringValue,
          }}
          className={styles.input}
          disabled={muted}
        />
      </Box>
    </Box>
  )
}
